import { PostReaction } from "models/postReaction";

import { AppLog } from "services";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { Service } from "utils/services";
import { create } from "zustand";

interface WatchTimeState {
  activePost: any | null;
  watchTime: number;
  setActivePost: (post: any | null) => void;
}

export const useWatchTime = create<WatchTimeState>((set, get) => {
  let timer: NodeJS.Timeout | null = null;
  let startTime: number | null = null;

  return {
    activePost: null,
    watchTime: 0,

    setActivePost: async (post) => {
      try {
        const { activePost } = get();

        if (activePost?.id !== post?.id) {
          // ✅ Stop previous tracking and reset the timer
          if (timer) {
            clearInterval(timer);
            timer = null;
            if (startTime) {
              const watchDuration = Math.floor((Date.now() - startTime) / 1000);
              if (watchDuration > 0) {
                console.log(`[END WATCH] Post ${activePost?.provider_post_id} - Total: ${watchDuration} sec`);
              }

              if (watchDuration > 2) {
                let url = RouteApi.submitViewReaction;
                url += `token=${Service.token}`;

                const synchId = await Service.getSynchID();
                const now = new Date();

                const postViewData = {
                  post_views: [
                    {
                      user_id: activePost.user_id,
                      reaction_user_id: Service.userAuth.id,
                      post_id: activePost.provider_post_id,
                      attachment_id: activePost?.post_attachments[0]?.attachment_id ?? "",
                      provider_reaction_id: synchId,
                      reaction_datetime: Service.toDateTimeStr(now),
                      reaction_type: PostReaction.view.value,
                      reaction_status: "Yes",
                      reaction_second: watchDuration,
                      send_to_user_id: "",
                      share_to_user_id: "",
                      share_to_provider: "",
                      share_to_provider_account_id: "",
                      created_by: Service.userAuth.name,
                      created_at: Service.toDateTimeStr(now),
                      synch_unid: synchId,
                      synch_by: Service.userAuth.name,
                      synch_status: "New",
                      synch_at: Service.toDateTimeStr(now),
                    },
                  ],
                };

                const responses = await RequestApi(url, { data: postViewData });
                if (responses.status === "success") {
                  AppLog.show({
                    message: `${responses["msg"]}`,
                    status: StatusMsg.getType(responses["status"]),
                  });
                } else {
                  AppLog.show({
                    message: `[submitViewReaction] ${responses["msg"]}`,
                    status: StatusMsg.getType(responses["status"]),
                  });
                }
              }
            }
          }

          // ✅ Reset watch time when a new post starts
          if (post) {
            console.log(`[START WATCH] Post ${post.provider_post_id} (${post.media_type})`);
            startTime = Date.now();

            timer = setInterval(() => {
              set((state) => ({
                watchTime: state.watchTime + 1,
              }));
            }, 1000);
          } else {
            timer = null;
            set({ watchTime: 0 }); // ✅ Reset when no post is active
          }

          set({ activePost: post, watchTime: 0 }); // ✅ Stores full post object
        }
      } catch (error) {
        AppLog.show({
          message: `[setActivePost]`,
          status: StatusMsg.error,
          error,
        });
      }
    },
  };
});

